import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { socialNetworksReducer } from './SocialMedia';
import { overlayReducer } from './Overlay';
import { timelineReducer } from './Timeline';
import { contactReducer } from './ContactForm';

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly
export const rootReducer = combineReducers({
  // List reducers here
  socialNetworks: socialNetworksReducer,
  overlay: overlayReducer,
  timeline: timelineReducer,
  contactForm: contactReducer
});

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([]);
}



// WEBPACK FOOTER //
// ./src/store/index.js